import { render, staticRenderFns } from "./About3.vue?vue&type=template&id=09ca0a6c"
import script from "./About3.vue?vue&type=script&lang=js"
export * from "./About3.vue?vue&type=script&lang=js"
import style0 from "./About3.vue?vue&type=style&index=0&id=09ca0a6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports